import api from "./api";

export default class TransferApiNovo {
  static postTransferSolicitation = async (obj: any, code: any) => {
    try {
      const response = await api.post(`/transferenciasNovo`, obj, {
        headers: {
          codigo: code,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  static getTransferSolicitation = async (
    idStatus: number,
    idCliente: number,
    dataInicio: string,
    dataFim: string,
    Page: number,
    RecordsPerPage: number,
    Search: string,
    minValue: number,
    maxValue: number,
    isManual: boolean
  ) => {
    const manualParam = isManual ? "&manual=true" : "";
    const response = await api.get(
      `/transferenciasNovo?idStatus=${idStatus}&idCliente=${idCliente}&dataInicio=${dataInicio}&dataFim=${dataFim}&Page=${Page}&RecordsPerPage=${RecordsPerPage}&Search=${Search}&valorInicio=${minValue}&valorFim=${maxValue}${manualParam}`
    );
    return response;
  };

  static getTransferPerId = async (idTransfer: any) => {
    const response = await api.get(`/transferenciasNovo/${idTransfer}`);
    return response.data;
  };

  static deleteTransferPerId = async (id: number) => {
    const response = await api.delete(`/transferenciasNovo/${id}/cancelar`);
    return response.data;
  };
  static exportTransferencia = async (
    idStatus: any,
    valorInicio: any,
    valorFim: any,
    dataInicio: any,
    dataFim: any,
    id: any,
    search: string
  ) => {
    const response = await api.get(
      `/transferenciasNovo/exportacao/download?idStatus=${idStatus}&idCliente=${id}&dataInicio=${dataInicio}&dataFim=${dataFim}&valorInicio=${valorInicio}&valorFim=${valorFim}&Search=${search}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };
}
